import ReactDOM from 'react-dom';
import React from 'react';
import { useEffect, useState, useRef } from 'react';

const Popup = ({ stick, className, height, width, children, onOutsideClick = () => {} }) => {

	const classes = '-wrapper' + (className ? ' ' + className : '');
	const [position, setPosition] = useState({ top: 9999, left: 0 });
	const [isOpen, setIsOpen] = useState(false);
	const [cursorPostion, setCusorPosition] = useState({
		type: 'left',
		top: 0
	});
	const boxRef = useRef();

	useEffect(() => {
		if (!stick) return;
		const rect = stick.getBoundingClientRect();
		if (!rect) return;
		const spacing = 15;

		const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

		// 計算方式
		// 1. 先獲取定位，位於需求 div 的右方並且對齊中線
		let top = rect.top - (height / 2 - rect.height / 2);
		let left = spacing + rect.left + rect.width;
		let cusorType = 'left';
		let cusorTop = 0;

		// 2. 判斷該視窗位置是否超出邊界，只判斷右邊和下面
		// 2.1 下面超過則往上抬
		if (top + height > windowHeight) {
			// 要減去scroll bar 的高度
			top = windowHeight - height - 15;
		}

		// 2.2 如果右邊超過則需要改到左邊位置呈現
		if(left + width > windowWidth) {
			left = rect.left - spacing - width < 0 ? 0 : rect.left - spacing - width;
			cusorType = 'right';
		}

		// 3. 獲取箭頭高度相對位置
		cusorTop = rect.top - top + (rect.height / 2) - 6;

		// 4. 箭頭不能超過popup最大高度
		if (cusorTop > (height - 25)) {
			cusorTop = height - 25;
		}

		setPosition({
			top,
			left,
		});
		setCusorPosition({
			type: cusorType,
			top: cusorTop
		});

		// 避免瞬間樣式渲染的浮動
		setIsOpen(true);
	}, [stick]);

	return ReactDOM.createPortal(
		<div className='H2-Box' {...{
			ref: boxRef,
			style: {
				...isOpen ? {
					width: '100%',
					height: '100%',
					position: 'fixed',
					top: 0,
					left: 0
				} : null
			}
		}}>
			<div style={{
				position: 'absolute',
				width: '100%',
				height: '100%'
			}} onClick={() => {
				onOutsideClick?.();
			}}></div>
			<div className={classes} style={{
				height,
				width,
				...position
			}}>
				<div className={`pointer-${cursorPostion.type}`} style={{
					top: cursorPostion.top
				}}></div>
				{/* <div className={`pointer-${cursorPostion.type}`} style={{
					backgroundColor: 'red'
				}}> */}
				{ children }
			</div>
		</div>
	, document.body);
};

export {
	Popup
};
